module.exports = __webpack_public_path__ + "static/img/简介.f136360.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/简介.jpg
// module id = HIcj
// module chunks = 1